"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx3 = _interopRequireDefault(require("clsx"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _navigationHeader = _interopRequireDefault(require("../styles/navigation-header.css"));
var dataUtils = new _mmcDataUtilities["default"]();
var isEmptyArray = dataUtils.isEmptyArray,
  handleNestedProp = dataUtils.handleNestedProp;
var SubNavLinks = function SubNavLinks(_ref) {
  var reducedHeight = _ref.reducedHeight,
    totalSetSize = _ref.totalSetSize,
    name = _ref.name,
    displayNavInTwoColumns = _ref.displayNavInTwoColumns,
    market = _ref.market,
    theme = _ref.theme,
    subNavigationItems = _ref.subNavigationItems,
    keyHandlerMethod = _ref.keyHandlerMethod,
    mobileNavActive = _ref.mobileNavActive,
    hideArrows = _ref.hideArrows;
  var refList = {};
  var keyHandler = function keyHandler() {
    keyHandlerMethod.apply(void 0, arguments);
  };
  var publishMenuClickToDataLayer = function publishMenuClickToDataLayer(mainMenu, linkUrl, subMenu, title, market) {
    if (market.toLowerCase() === 'us' && typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'navclick',
        component: 'top_nav',
        action: 'inner_link',
        section_name: mainMenu,
        click_text: subMenu,
        inner_section: title
      });
      if (['/concesionarios', '/localizador-concessionarios', '/loyda-lahin-jalleenmyyjasi'].includes(linkUrl)) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'dealer_locator_click',
          comp_page: {
            position: 'top menu'
          }
        });
      }
      if (['/comprar/configurador', '/osta/rakenna-oma-mitsubishi', '/osta/rakenna-oma-mitsubishi/rakenna-autosi'].includes(linkUrl)) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'car_configuration_click',
          comp_product: {
            position: 'top menu',
            vehicle_type: 'car',
            brand: 'mitsubishi',
            product_condition: 'new',
            model: null,
            version: null,
            color: null,
            upholstery: null,
            accesories: null,
            fuel_type: null,
            price: null,
            currency: null
          }
        });
      }
      if (['/servicio/citataller', '/omistajuus/varaa-huolto'].includes(linkUrl)) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'maintenance_request_click',
          comp_product: {
            position: 'top menu',
            vehicle_type: 'car',
            brand: 'mitsubishi',
            product_condition: 'new',
            model: null,
            version: null,
            fuel_type: null,
            dealer_name: null
          }
        });
      }
      if (['/prueba', '/test-drive', '/varaa-koeajo'].includes(linkUrl)) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'test_drive_request_click',
          comp_product: {
            position: 'top menu',
            vehicle_type: 'car',
            brand: 'mitsubishi',
            product_condition: 'new',
            model: null,
            version: null,
            fuel_type: null,
            dealer_name: null
          }
        });
      }
    }
  };
  var renderItemLink = function renderItemLink(settings) {
    var checkedSettings = {
      link: handleNestedProp(settings, 'settings.link'),
      i: handleNestedProp(settings, 'settings.i'),
      totalSetSize: handleNestedProp(settings, 'settings.totalSetSize'),
      name: handleNestedProp(settings, 'settings.name'),
      market: handleNestedProp(settings, 'settings.market'),
      title: handleNestedProp(settings, 'settings.title')
    };
    var link = checkedSettings.link;
    var market = checkedSettings.market;
    var title = checkedSettings.title;
    var checkedLink = {
      label: handleNestedProp(link, 'link.label'),
      url: handleNestedProp(link, 'link.url'),
      openNewTab: handleNestedProp(link, 'link.openNewTab')
    };
    var setSize = checkedSettings.totalSetSize;
    var posInSet = checkedSettings.i + 1;
    var name = checkedSettings.name + "_" + checkedLink.label;
    refList[name] = refList[name] || {};
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: checkedLink.label + "-" + checkedSettings.i,
      className: _navigationHeader["default"].navItemLink + " menu-panel-sub-list-item",
      ref: function ref(el) {
        refList[name][checkedSettings.i] = el;
        return el;
      },
      onKeyUp: function onKeyUp(e) {
        return keyHandler(e, checkedSettings.i, refList[name][checkedSettings.i]);
      },
      role: "menuitem",
      "aria-setsize": setSize,
      "aria-posinset": posInSet,
      "data-menu-item-name": name,
      "data-menu-item-parent-name": checkedSettings.name
    }, /*#__PURE__*/_react["default"].createElement("a", {
      className: _navigationHeader["default"].dropDownLinkAnchor,
      href: "" + checkedLink.url,
      "data-section": checkedSettings.name,
      target: checkedLink.openNewTab ? '_blank' : '',
      onClick: function onClick() {
        return publishMenuClickToDataLayer(checkedSettings.name, checkedLink.url, checkedLink.label, title, market);
      }
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _navigationHeader["default"].navLinkLabel + " " + theme.introCopy + " " + (!hideArrows && theme.mmcIconChevronRight)
    }, "" + checkedLink.label)));
  };
  var renderLinks = function renderLinks(params) {
    var links = params.links,
      title = params.title;
    return !isEmptyArray(links) && links !== ' ' && /*#__PURE__*/_react["default"].createElement("ul", {
      className: _navigationHeader["default"].navLinkList + " " + _navigationHeader["default"].linksList + " " + (reducedHeight ? _navigationHeader["default"].reduced : '') + "\n          } " + _navigationHeader["default"].newNavList
    }, links.map(function (link, i) {
      return renderItemLink({
        link: link,
        i: i,
        totalSetSize: totalSetSize,
        name: name,
        displayNavInTwoColumns: displayNavInTwoColumns,
        market: market,
        title: title
      });
    }));
  };
  var isAllColumnTitleLess = function isAllColumnTitleLess(subNavigationItems) {
    return subNavigationItems.every(function (item) {
      return (item == null ? void 0 : item.title) === null;
    });
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "" + theme.row
  }, subNavigationItems && !isEmptyArray(subNavigationItems) && subNavigationItems.map(function (navItem, index) {
    var _clsx, _clsx2;
    var links = navItem.links,
      title = navItem.title;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx3["default"])((_clsx = {}, _clsx[theme['col-xs-12']] = !mobileNavActive, _clsx[theme['col-md-4']] = !mobileNavActive, _clsx[theme['col-xs-12']] = mobileNavActive, _clsx))
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _clsx3["default"])(_navigationHeader["default"].subNavTitle, (_clsx2 = {}, _clsx2[_navigationHeader["default"].noTitle] = isAllColumnTitleLess(subNavigationItems), _clsx2))
    }, title), renderLinks({
      links: links,
      reducedHeight: reducedHeight,
      totalSetSize: totalSetSize,
      name: name,
      displayNavInTwoColumns: displayNavInTwoColumns,
      market: market,
      index: index,
      title: title,
      mobileNavActive: mobileNavActive
    }));
  }));
};
SubNavLinks.displayName = 'SubNavLinks';
SubNavLinks.defaultProps = {
  subNavigationItems: []
};
var _default = SubNavLinks;
exports["default"] = _default;